import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import { FormattedMessage } from 'react-intl'
import { Pagination } from 'components/misc'
import TableHeader from './TableHeader'
import TableLoader from './TableLoader'
import styles from './table.styl'

import filterThs from 'utils/filter-ths'

const defaultLimitOptions = [
  {
    value: 5,
    label: 5
  },
  {
    value: 10,
    label: 10
  },
  {
    value: 20,
    label: 20
  },
  {
    value: 50,
    label: 50
  }
]

export default class Table extends Component {
  static propTypes = {
    children: PropTypes.any,
    permissions: PropTypes.object,
    loading: PropTypes.bool,
    selectable: PropTypes.bool,
    areAllSelected: PropTypes.bool,
    bulkSelect: PropTypes.func,
    length: PropTypes.number,
    limit: PropTypes.number,
    onSetLimit: PropTypes.func,
    offset: PropTypes.number,
    pages: PropTypes.number,
    sort: PropTypes.string,
    filter: PropTypes.string,
    onPaginationChange: PropTypes.func,
    exportComponent: PropTypes.node,
    onLimitChange: PropTypes.func,
    onSortChange: PropTypes.func,
    setParams: PropTypes.func,
    ths: PropTypes.array,
    hideLimit: PropTypes.bool,
    hidePagination: PropTypes.bool,
    limitOptions: PropTypes.object
  }

  static defaultProps = {
    loading: false,
    length: 1,
    ths: [],
    selectable: false,
    hidePagination: false
  }

  static Td = ({ children }) => (
    <td><span className={styles.flexify}>{children}</span></td>
  )

  componentWillMount() {
    if (
      this.props.onLimitChange ||
      this.props.onPaginationChange ||
      this.props.onSortChange
    ) {
      console.warn(
        'This component is not using the latest setParams action, please refactor'
      )
    }
  }

  handleLimitChange = o => {
    const { setParams, onSetLimit } = this.props

    setParams({ limit: o.value })
    onSetLimit && onSetLimit(o.value)
  }

  render() {
    const {
      children,
      loading,
      length,
      offset,
      limit,
      pages,
      count,
      sort,
      filter,
      ths,
      setParams,
      selectable,
      areAllSelected,
      bulkSelect,
      permissions,
      hideLimit,
      exportComponent,
      hidePagination,
      limitOptions
    } = this.props

    const selectableClass = selectable ? styles.selectable : ''
    const thsLength = filterThs(ths, permissions).length

    return (
      <div>
        <TableLoader loading={loading} ths={ths} />

        {!loading &&
          <div>
            <div>
              <table
                className={`${styles.table} ${selectableClass}`}
              >
                {thsLength !== 0 &&
                  <TableHeader
                    ths={ths}
                    sort={sort}
                    onSortChange={setParams}
                    permissions={permissions}
                    areAllSelected={areAllSelected}
                    bulkSelect={bulkSelect}
                  />}
                {children}
                {length === 0 &&
                  <tbody>
                    <tr>
                      <td colSpan={thsLength} className="text--center">
                        {!filter &&
                          <FormattedMessage
                            id="table.no_results"
                            defaultMessage="No results"
                          />}
                        {filter &&
                          <FormattedMessage
                            id="table.no_filtered_results"
                            defaultMessage="Filter is active"
                          />}
                      </td>
                    </tr>
                  </tbody>}
              </table>
              {length > 0 && !hidePagination &&
                <div className="row">
                  {setParams &&
                    !hideLimit &&
                    <div className="col-xs-5">
                      <ReactSelect
                        onChange={this.handleLimitChange}
                        value={limit}
                        className={`form-control--select ${styles.select}`}
                        options={limitOptions || defaultLimitOptions}
                        placeholder=""
                        searchable={false}
                      />
                      <div className={styles.selectLabel}>
                        <FormattedMessage
                          id="table.per_page"
                          defaultMessage="per page"
                        />
                      </div>
                    </div>}

                  {!setParams && <div className="col-xs-5" />}

                  {count && <div className={`col-xs-2`}>
                    <div className={styles.count}>
                        <FormattedMessage
                          id="label.number_of_records"
                          defaultMessage="Number of records"
                        />: {count}
                    </div>
                  </div>}
                  {!count && <div className="col-xs-2" />}

                  <div className="col-xs-5">
                    <div className="clear">
                      <Pagination
                        className={styles.pagination}
                        offset={offset}
                        limit={limit}
                        pages={pages}
                        onChange={setParams}
                      />
                      {exportComponent &&
                        <div
                          className={`${styles.export} ${pages === 1 ? styles.noPagination : ''}`}
                        >
                          {exportComponent}
                        </div>}
                    </div>
                  </div>
                </div>}
            </div>
          </div>}
      </div>
    )
  }
}
